import { render, staticRenderFns } from "./DeviceVersionsForm.vue?vue&type=template&id=77eb3f0f&"
import script from "./DeviceVersionsForm.vue?vue&type=script&lang=ts&"
export * from "./DeviceVersionsForm.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceVersionsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports